import React, {useContext} from "react";
import {View, Text, Image} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";
import {LOWES_DISCLAIMER_EN} from "../../../misc/fabricatorHardcode";

const warningIcon = `https://qc-cdn.s3.amazonaws.com/receipt/icon-warning-red.jpg`;

const PrintDocumentDisclaimer = (props) => {
  const {fabricatorData, locale, styles, withTotal} = props;
  const fabricatorSettings = fabricatorData.settings;
  const printContext = useContext(PrintDocumentContext);

  if (!fabricatorSettings.depositDisclaimer || !fabricatorSettings.enableDisclaimer) {
    return null
  }
  if (withTotal && fabricatorSettings.depositDisclaimer.length >= 1500
    || !withTotal && fabricatorSettings.depositDisclaimer.length < 1500) {
    return null
  }

  const getDisclaimerMessage = () => {
    if ((fabricatorData.isLowes || fabricatorData.isCaesarStone)) {
      if (locale === "fr-FR" && printContext.messages["transDoc.description_FR._disclaimer"]) {
        return printContext.messages["transDoc.description_FR._disclaimer"]
      } else if (locale === "pl-PL" && printContext.messages["transDoc.customTranslateDescription_PL._disclaimer"]) {
        return printContext.messages["transDoc.customTranslateDescription_PL._disclaimer"]
      } else if (printContext.messages["transDoc.customDisplayName_FR._disclaimer"]) { // it is actually EN ! hardcoded for lowes profiles
        return printContext.messages["transDoc.customDisplayName_FR._disclaimer"]
      } else if (fabricatorData.isLowes) {
        return LOWES_DISCLAIMER_EN
      }
    }
    return fabricatorSettings.depositDisclaimer
  }

  const disclaimerMessage = getDisclaimerMessage();

  // if (withTotal) {
  //   return (
  //     <View style={styles.notification}>
  //       <Image style={styles.notificationImage} src={warningIcon} />
  //       <Text style={styles.notificationText}>{disclaimerMessage}</Text>
  //     </View>
  //   )
  // }

  return (
    <View style={withTotal ? styles.notification : [styles.notification, styles.notificationMargin]}>
      <Image style={styles.notificationImage} src={warningIcon} />
      <Text style={styles.notificationText}>{disclaimerMessage}</Text>
    </View>
  )

};

PrintDocumentDisclaimer.propTypes = {
  discountSections: PropTypes.array.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  withTotal: PropTypes.bool,
};

export default PrintDocumentDisclaimer
